import * as Parsimmon from 'parsimmon';

import { DatabaseSortDirection, TokenType } from '../types.ts';

export const SortLang = Parsimmon.createLanguage({
  /**
   * <Statement> -> [<Expression>(, <Expression>)*]
   *
   * The brackets are terminals.
   * @param r - language
   */
  Statement: function (r) {
    return r.Expression.sepBy1(Parsimmon.string(',').skip(Parsimmon.optWhitespace)).wrap(
      Parsimmon.string('['),
      Parsimmon.string(']')
    );
  },

  /**
   * <Expression> -> <FieldName> <Direction>
   *
   * @param r - language
   */
  Expression: function (r) {
    return Parsimmon.seq(
      r.FieldName.skip(r._),
      r.Direction.skip(Parsimmon.optWhitespace)
    ).map(([fieldName, direction]) => ({
      tokenType: TokenType.SORT,
      fieldName,
      direction
    }));
  },

  /**
   * <FieldName> -> Examples: 'FieldName', 'My Field 1'
   *
   * This is a terminal.
   * A <FieldName> is anything wrapped in single quotes
   */
  FieldName: function () {
    const escapedChar = Parsimmon.string('\\')
      .then(Parsimmon.any)
      .map((c) => c);
    const normalChar = Parsimmon.noneOf("'");
    const content = Parsimmon.alt(escapedChar, normalChar);

    return Parsimmon.string("'")
      .then(content.many().map((chars) => chars.join('')))
      .skip(Parsimmon.string("'"));
  },
  /**
   * <Direction> -> "asc" | "ASC" | "desc" | "DESC"
   *
   * This is a terminal.
   * An <Direction> is a group of select literals
   */
  Direction: function () {
    return Parsimmon.alt(
      Parsimmon.string('DESC').map(() => DatabaseSortDirection.DESC),
      Parsimmon.string('desc').map(() => DatabaseSortDirection.DESC),
      Parsimmon.string('asc').map(() => DatabaseSortDirection.ASC),
      Parsimmon.string('ASC').map(() => DatabaseSortDirection.ASC)
    );
  },

  _: function () {
    return Parsimmon.whitespace;
  }
});
